module.exports = {
	"base": {
		"welcome": "¡Bienvenido a Mulligans, %{name}!",
		"user": "Información de usuario",
		"devices": "Dispositivos",
		"refunds": "Devoluciones",
		"resources": "Recursos",
		"transactions": "Transacciones y reembolsos",
		"email": "Correo electrónico",
		"password": "Contraseña",
		"save": "Guardar",
		"sign-out": "Cerrar sesión",
		"cancel": "Cancelar",
		"close": "Cerrar",
		"learn-more": "Más informacíón",
		"required": "Requisito",
		"support": "Asistencia técnica",
		"bookshelf": "Librería",
		"launch": "Iniciar",
		"download": "Descargar",
		"details": "Detalles",
		"cannot-be-blank": "%{field} no puede estar en blanco.",
		"saving": "Guardando...",
		"done": "Listo",
		"failed": "Error",
		"copy": "Copiar"
	},
	"signin": {
		"login-failure": "El correo electrónico o la contraseña es incorrecto",
		"welcome-large": "Bienvenido al centro de cuentas de <span class='inner'>%{brand}</span>",
		"welcome-small": "<span class='inner'>Centro de cuentas</span>",
		"signin-button": "Identificarse",
		"forgot-password": "¿Ha olvidado su contraseña?",
		"new-to-vst": "¿Nuevo en %{brand}?",
		"create-account": "Crear una cuenta",
		"signing-in": "Identificándose...",
		"signin-failed": "Se ha producido un error en la identificación"
	},
	"transactions": {
		"price": "Precio",
		"excluded": "(Impuestos no incluidos)",
		"quantity": "Cantidad",
		"confirmation#": "N.º de confirmación",
		"payment": "Pago",
		"purchased": "Comprado",
		"purchase-details": "Detalles de la compra",
		"subtotal": "Subtotal",
		"total": "Total",
		"tax": "Impuesto",
		"loading": "Ey, gran consumidor, estamos cargando sus transacciones...",
		"no-purchases": "No tiene ninguna compra.",
		"seller-vat": "IVA del vendedor",
		"total-vat": "%{vat} total pagado",
		"portion": "Impuesto de %{subTax} del %{rate} %",
		"vat-disclosure": "El precio incluye el %{vat} % de IVA",
		"purchases": "Compras",
		"refunded-items": "Artículos devueltos",
		"book-title": "Título del libro",
		"refund-details": "Detalles de reintegro",
		"print-receipt": "Imprimir recibo",
		"request-refund": "Solicitar reembolso",
		"expired": "Caducado",
		"expires-in": "Caduca el %{date}",
		"details-refund": "Detalles y reembolso",
		"modal": {
			"cant-refund-title": "Devolución no disponible",
			"cant-refund": "No es posible devolver su libro por una o más de una de las siguientes razones.",
			"cant-refund-1": "Se ha visualizado una gran parte del libro.",
			"cant-refund-2": "Han pasado más de 14 días desde la fecha de compra.",
			"cant-refund-3": "Se ha mostrado su código de recursos en línea.",
			"cant-refund-4": "Su libro se ha devuelto anteriormente.",
			"cant-refund-5": "Todos los códigos ya se han canjeado y/o devuelto.",
			"cant-refund-6": "Han pasado más de 30 días desde la fecha de compra.",
			"cant-refund-support": "Si todavía tiene dudas acerca de la política de devoluciones de %{brand}, póngase en contacto con <a href='%{support_url}' target='_blank'>la asistencia técnica.</a>"
		},
		"license": {
			"perpetual": "El acceso en línea no caduca",
			"days": "Acceso de %{days} día"
		}
	},
	"devices": {
		"description": "%{brand} le permite tener <span>%{desktop}</span> ordenadores y <span>%{mobile}</span> dispositivos móviles o tabletas activados a la vez.",
		"loading": "Ey, estamos accediendo a sus dispositivos :)",
		"no-active": "No tiene dispositivos activos.",
		"deactivate": "Desactivar"
	},
	"user": {
		"personal-information": "Información personal",
		"security-information": "Información de seguridad",
		"notifications": "Notificaciones",
		"first-name": "Nombre",
		"last-name": "Apellido",
		"change-password-title": "Cambiar contraseña",
		"current-password": "Contraseña actual",
		"new-password": "Contraseña nueva",
		"security-password": "Contraseña",
		"confirm-new-password": "Confirmar contraseña nueva",
		"security-question": "Pregunta de seguridad",
		"security-info-change": "Cambiar",
		"question": "Pregunta",
		"answer": "Respuesta",
		"notifications-text": "Deseo recibir actualizaciones sobre actividad en mi cuenta, productos y ofertas especiales por correo electrónico.",
		"loading": "Spot está recopilando su información de usuario; espere un segundo 🐶",
		"change-password-text": "La contraseña debe contener al menos 8 caracteres, una mayúscula, una minúscula y un carácter especial.",
		"email-locked": "Correo electrónico bloqueado",
		"email-locked-description": "No tiene acceso al cambio del correo electrónico.",
		"email-locked-more": "Póngase en contacto con el administrador.",
		"security-question6": "¿Cuál es su deporte favorito?",
		"security-question7": "¿Cuál es su sabor de helado favorito?",
		"security-question8": "¿Cómo se llama su mascota favorita?",
		"security-question9": "Cuando era pequeño/a, ¿qué quería ser de mayor?",
		"security-question10": "¿Cuál era el apellido de su profesor/a favorito/a?",
		"new-password-failure": "La contraseña no cumple los requisitos",
		"confirm-password-failure": "La contraseña debe coincidir",
		"new-password-tooltip": "Debe contener al menos 8 caracteres, una mayúscula, una minúscula y un carácter especial.",
		"enter-valid-email": "Escriba un correo electrónico válido.",
		"password-cannot-be-same": "La contraseña no puede ser la misma que la contraseña anterior",
		"incorrect-password": "Contraseña incorrecta",
		"complete-account": "Parece que debes <a href='%{href}'>completar tu cuenta</a>.",
		"completing-allows": "Cuando la completes podrás leer libros sin conexión en tus dispositivos móviles y compartir con tus amigos notas y resaltados.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Auxiliares",
		"access-codes": "Códigos de acceso",
		"print-on-demand": "Imprimir a petición",
		"check-pod": "Comprueba las opciones de impresión del editor para tus libros.",
		"check-now": "Comprobar ahora",
		"loading": "¡Un momento, estamos actualizando sus recursos!",
		"in": "en",
		"access-code-intro": "Un código de acceso es una contraseña que se utiliza para acceder al contenido del curso en línea. Una vez que muestre el código de un artículo, ya no podrá devolverlo. Para más instrucciones sobre el uso de los códigos de acceso, visite la <a href='%{support_url}' target='_blank'>Asistencia técnica</a>.",
		"expires": "Caduca",
		"expiration-message": "Contiene instrucciones sobre el uso del código de acceso.",
		"copy-fail": "No se puede copiar. Seleccione el código y cópielo manualmente.",
		"launch-site": "Iniciar sitio",
		"launch-book": "Iniciar libro",
		"reveal-code": "Mostrar código",
		"no-resources": "No tiene ningún recurso.",
		"no-access-codes": "No tiene ningún código de acceso.",
		"no-ancillaries": "No hay auxiliares para este título",
		"name": "Nombre",
		"type": "Tipo",
		"size": "Tamaño",
		"download-all": "Descargar todo",
		"back": "Volver a los recursos"
	},
	"refunds": {
		"states": {
			"refunded": "Devuelto",
			"unavailable": "Devolución no disponible"
		},
		"reasons": {
			"dropped": "He abandonado el curso",
			"wrong": "Este libro no era el correcto para el curso",
			"print": "He decidido comprar una versión impresa",
			"missing": "El libro no contiene todo lo que necesito para el curso (por ejemplo un CD, acceso a la web, vídeos...)",
			"other": "Otro"
		},
		"bulk": {
			"policy": "Entiendo que al hacer clic en el botón &quot;Completar devolución&quot; de más abajo acepto la política de devoluciones de %{brand} <a href='%{policy_url}' target='_blank'>.</a>",
			"complete": "Completar devolución",
			"view-details": "Ver detalles de devolución",
			"success": "Se ha solicitado tu reembolso. Espera 48 horas para el procesamiento.",
			"failure": "¡Vaya! Algo ha salido mal. Lamentablemente la devolución no se ha procesado.",
			"retry": "Intentar de nuevo",
			"support": "Ponerse en contacto con la asistencia técnica",
			"available-codes": "Códigos disponibles",
			"codes-selected": "Códigos seleccionados",
			"download": "Descargar códigos",
			"partially-refunded": "Devuelto parcialmente",
			"pick-one": "Debe seleccionar al menos un código para realizar una devolución"
		},
		"refund": "Devolver",
		"all": "¿Devolver todo?",
		"missing-reason": "Debe seleccionar una razón para continuar",
		"missing-elaboration": "Indique detalles",
		"policy": "Al hacer clic en el botón \"Completar solicitud de devolución\" de más abajo, entiendo que si vuelvo a comprar este libro de texto electrónico de %{brand}, no podré solicitar más devoluciones del mismo libro de texto electrónico. Consulte la política de devoluciones.",
		"refunded": "Devuelto",
		"sorry": "Lamentamos mucho que no esté satisfecho con su compra.",
		"error": "Algo ha salido mal",
		"error-explain": "No hemos podido procesar su devolución. Inténtelo de nuevo.",
		"why": "Cuéntenos por qué",
		"no-refunds": "No tiene artículos devueltos.",
		"select-codes": "Seleccione código(s) de devolución:",
		"number": "¿Cuántas?",
		"back": "Volver a las devoluciones"
	},
	"purchases": {
		"back": "Volver a las compras"
	},
	"global-bar": {
		"account": "Configuración de cuenta"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/es.json
 ** module id = 980
 ** module chunks = 0
 **/